import { useTranslations } from 'next-intl';
import BottomSheetModal from '@/components/shared/BottomSheetModal';
import { infoDailyRewardCards } from '../utils/dailyInfoRewardsCards';
import { DailyInfoCard } from './DailyCardInfo';

const DESCRIPTION_KEYS = ['description', 'description-2', 'description-3'] as const;

interface Props {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}
const DailyBonusInformationDrawer = ({ isOpen, setIsOpen }: Props) => {
  const t = useTranslations('daily-bonus.information');
  return (
    <BottomSheetModal
      open={isOpen}
      onOpenChange={setIsOpen}
      classNameDrawerContent="pb-0 px-0"
      contentClassName="overflow-x-visible max-h-[80dvh] overflow-y-auto hide-scrollbar pb-0"
      classNamePointer="mb-3"
    >
      <ul className="flex flex-col gap-2 list-none mt-3 mb-4 mx-6">
        {DESCRIPTION_KEYS.map(key => (
          <li key={key} className="flex items-start gap-2 text-base leading-6 font-normal pl-2">
            <span className="size-1 rounded-full bg-white shrink-0 mt-[0.688rem] ml-0.5" />
            {t(key)}
          </li>
        ))}
      </ul>
      <h3 className="text-lg font-semibold leading-7 mb-4 mx-6">{t('card-states')}</h3>
      <div className="flex flex-col gap-2.5 overflow-x-visible mb-4 mx-6">
        {
          infoDailyRewardCards.map(card => (
            <DailyInfoCard
              variantCard="desktop"
              key={card.titleKey}
              redirectToShop
              amountClassName="text-sm leading-5 font-medium"
              className="min-w-0 w-18.5! h-29! shrink-0"
              {...card}
            />
          ))
        }
      </div>
      <p className="font-semibold text-lg leading-7 text-gradient bg-promo-banner-title-gradient mb-3 mx-6">
        {t('don-t-miss-a-day')}
      </p>
      <p className="font-normal text-base leading-6 mb-5 mx-6">
        {t.rich('unclaimed-activations-expire-at-midnight-each-opened-card-uses-1-activation', {
          br: () => <br />,
        })}
      </p>
    </BottomSheetModal>
  );
};

export default DailyBonusInformationDrawer;
